import { useState } from 'react';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      q: 'Что такое YOYBUY Spreadsheet?',
      a: 'YOYBUY Spreadsheet — это система управления закупками из Китая, представленная в виде структурированной таблицы. Она содержит данные о товарах, ценах, поставщиках и логистике, что делает процесс sourcing быстрым и прозрачным.',
    },
    {
      q: 'Это бесплатно?',
      a: 'Да, базовый доступ к YOYBUY Spreadsheet предоставляется бесплатно. Вы можете просматривать основные категории товаров и сравнивать платформы без какой-либо оплаты.',
    },
    {
      q: 'Чем отличается Kakobuy Spreadsheet?',
      a: 'Kakobuy Spreadsheet ориентирован на скорость обработки заказов. Платформа Kakobuy быстрее обрабатывает запросы, но YOYBUY предлагает более низкие цены и широкий выбор товаров.',
    },
    {
      q: 'Можно ли зарабатывать с YOYBUY Spreadsheet?',
      a: 'Да, система идеально подходит для дропшиппинга и перепродажи товаров. Вы можете находить товары по низким ценам, анализировать маржинальность и строить прибыльный бизнес на товарах из Китая.',
    },
    {
      q: 'Какие платформы поддерживаются?',
      a: 'YOYBUY Spreadsheet поддерживает три основные платформы для закупок: YOYBUY (основная), Kakobuy (быстрая альтернатива) и Superbuy (премиум-уровень). Каждая платформа имеет свою специализацию.',
    },
    {
      q: 'Как часто обновляются данные в таблице?',
      a: 'Данные в YOYBUY Spreadsheet обновляются еженедельно. Мы отслеживаем изменения цен, новые поступления и отзывы о поставщиках, чтобы вы всегда имели актуальную информацию.',
    },
    {
      q: 'Нужна ли регистрация для доступа?',
      a: 'Для просмотра базовой версии YOYBUY Spreadsheet регистрация не требуется. Для расширенного доступа с дополнительными функциями аналитики потребуется создать аккаунт на основном сайте.',
    },
  ];

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-20 md:py-28 px-6 md:px-10 lg:px-16 bg-background-50">
      <div className="max-w-3xl mx-auto">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="text-xs font-semibold text-foreground-400 uppercase tracking-[0.2em]">FAQ</span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mt-3 leading-tight">
            Часто задаваемые вопросы
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-md mx-auto">
            Ответы на самые популярные вопросы о YOYBUY Spreadsheet
          </p>
        </div>

        {/* FAQ accordion */}
        <div className="flex flex-col gap-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="rounded-2xl border border-background-200 bg-background-50 overflow-hidden transition-all duration-300"
            >
              <button
                onClick={() => toggleFaq(idx)}
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer"
              >
                <span className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {faq.q}
                </span>
                <span className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${
                  openIndex === idx ? 'rotate-180' : ''
                }`}>
                  <i className="ri-arrow-down-s-line text-foreground-400 text-lg"></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === idx ? 'max-h-96 pb-5' : 'max-h-0'
                }`}
              >
                <p className="px-6 text-sm text-foreground-500 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}